import Vue from 'vue'
import VueI18n from './VueI18n'

export const numberFormat = (number = 0) => {
  const num = parseFloat(number)
  if (num === 0 || num) {
    return num.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return '-'
}

Vue.filter('NumberFormat', numberFormat)

Vue.filter('ingredientStatus', (val) => {
  switch (val) {
    case 'controlled':
      return VueI18n.t('ingredient.status.controlled')
    case 'exceed':
      return VueI18n.t('ingredient.status.exceed')
    case 'lower':
      return VueI18n.t('ingredient.status.lower')
    default: return null
  }
})

Vue.filter('fullNumberWithDigit', (val) => Number(val).toLocaleString(
  undefined,
  {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
))

export default {
  numberFormat
}
